import React from 'react';
import { Flex } from '..';

export default function Columns({
  children,
  orientation = 'LEFT',
  style,
  ...rest
}) {
  return (
    <Flex
      style={[
        {
          // flexGrow: 1 is required for <BaseText> to inherit width
          flexGrow: 1,
          flexDirection: orientation === 'LEFT' ? 'row' : 'row-reverse',
        },
        style,
      ]}
      {...rest}
    >
      {children}
    </Flex>
  );
}
